<script>
  import { createEventDispatcher } from 'svelte';
  import Tooltip from '../../Common/Tooltip/Tooltip.svelte';
  import {
    channelFilterText,
    showArchivedChannels,
    showOnlyMyChannels,
    categories,
    selectedChannelTypeFilter,
  } from '../../../Store/store';

  const dispatch = createEventDispatcher();

  const filterInput = (e) => {
    channelFilterText.set(e.target.value);
    dispatch('filtersupdated');
  };

  const onClearFilterInputClicked = () => {
    channelFilterText.set('');
    dispatch('filtersupdated');
  };

  const onShowOnlyCreatedByMeClicked = () => {
    showOnlyMyChannels.set(!$showOnlyMyChannels);
    dispatch('filtersupdated');
  };

  const onShowArchivedChannelsClicked = () => {
    showArchivedChannels.set(!$showArchivedChannels);
    dispatch('showarchive');
  };

  const toggleChannelTypeFilter = (type) => {
    const currentSelected = [...$selectedChannelTypeFilter];
    if (type === 'all' && !$selectedChannelTypeFilter.includes('all')) {
      selectedChannelTypeFilter.set(['all']);
    } else if (type !== 'all' && !$selectedChannelTypeFilter.includes(type)) {
      const merged = [type, ...currentSelected].filter((t) => t !== 'all');
      selectedChannelTypeFilter.set(merged);
    } else if (type !== 'all' && $selectedChannelTypeFilter.includes(type)) {
      const merged = currentSelected.filter((t) => t !== type);
      if (!merged.length) {
        merged.push('all');
      }
      selectedChannelTypeFilter.set(merged);
    }
    dispatch('filtersupdated');
  };
</script>

<div class="filter-container">
  <div class="main">
    <div class="input">
      <input
        type="text"
        placeholder="Filtrer på navn"
        on:input={filterInput}
        value={$channelFilterText}
      />
      {#if $channelFilterText}
        <button class="clr-filter-btn" on:click={onClearFilterInputClicked}>
          <span class="material-icons"> close </span>
        </button>
      {/if}
    </div>
    <div class="btns">
      <Tooltip tooltip="Bare vis chat-rom du har opprettet">
        <button class:selected={$showOnlyMyChannels} on:click={onShowOnlyCreatedByMeClicked}>
          <span class="material-icons"> person </span>
        </button>
      </Tooltip>
      <Tooltip tooltip="Se arkiverte chat-rom">
        <button on:click={onShowArchivedChannelsClicked} class:selected={$showArchivedChannels}>
          <span class="material-icons"> inventory </span>
        </button>
      </Tooltip>
    </div>
  </div>
  <div class="channel-type-filter">
    {#each $categories as category}
      <button
        on:click={() => toggleChannelTypeFilter(category.type)}
        class:selected={$selectedChannelTypeFilter.includes(category.type)}
      >
        {category.displayName}
      </button>
    {/each}
  </div>
</div>

<style src="./filter.scss"></style>
